/**
 * Created by lingcy on 2017/3/9.
 */
import React, {
    Component,
    PropTypes
} from 'react';
import {
    Link
} from "react-router";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import {ellaUrl} from '../../../path.config'
import extendsService from 'SERVICES/ella/extendsService'
import {resultTip,pageOption,language} from 'UTIL/common'
import Tip from 'COMPONENT/tip'
import ModalDel from 'COMPONENT/ModalDel'
export default class ExtendsValue extends Component {
    constructor(props) {
        super(props);
        this.handle = this.handle.bind(this);
        this.delList = this.delList;
        this.delClick = this.delClick;
        this.search = this.search.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.userTypeChange = this.userTypeChange.bind(this);
        this.state = {
            list: [],
            size: 10,
            current: 1,
            total: 0,
            delRow: {id:"",name:""},
            userType:"",
            url: ellaUrl
        };
    }
    componentDidMount() {
        this.onPageChange(this.state.current,this.state.size)
    }
    handle(cell, row) {
        return (<div>
            <a className="btn btn-sm btn-danger" data-target="#tipModal" data-toggle="modal"
               onClick={this.delList.bind(this,row.id)}>{language()['delete']}</a>&nbsp;&nbsp;
        </div>);

    };
    delList(id) {
        var delRow = {
            id:id,
        };
        this.setState({
            delRow:delRow
        });
        console.log(delRow);
    };
    onPageChange(page, sizePerPage, e) {
        const name = $.trim($("#name").val());
        const json = {
            current:page,
            size:sizePerPage,
            search: name,
            userTypeId:this.props.params.userTypeId,
            userId:""
        };
        const data = JSON.stringify(json);
        extendsService.extendsList({data}).then(body=>{
            console.log(body)
            if(body.data !=null){
                this.setState({
                    current: page,
                    size: sizePerPage,
                    list : body.data.page.records,
                    total : body.data.page.total,
                    userType:body.data.userType,
                })}
        })
    }
    search() {
        this.onPageChange(this.state.current,this.state.size)
    }

    delClick(id){
        extendsService.delExtendsValue(id).then(data =>{
            resultTip(data,"/ella/user/userType/extendsValue/" + this.props.params.userTypeId);
            this.onPageChange(this.state.current,this.state.size)
        })
    }

    formTypeChange(cell,row){

        if(row.formType == "0"){
            return "文本";
        }else if(row.formType == "1"){
            return "文本区域";
        }else if(row.formType == '2'){
            return "文件"
        }else if(row.formType == '3'){
            return "密码"
        }else if(row.formType == "4"){
            return "图片";
        }else if(row.formType == '5'){
            return "下拉框"
        }else if(row.formType == "6"){
            return "复选框";
        }else if(row.formType == '7'){
            return "时间控件"
        }else if(row.formType == '8'){
            return "单选框"
        }
    }
    userTypeChange(cell,row){
        if(row.userTypeId == this.state.userType.id){
            return this.state.userType.name;
        }
    }

    render() {
        let options = pageOption(this.state.current,this.state.size);
        options['onPageChange'] = this.onPageChange.bind(this);
       function userTypeName(){
            return this.state.userType.name;
        }
        return (
            <div >
                <section className="content-header " >
                    <h1> {language()['userType']} <small>{language()['extended']}</small> </h1>
                </section>
                <section className="content" >
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-list"></i>
                            <h3 className="box-title">{language()['extendedList']}</h3>
                            <div style={{marginRight:"10px",float:"right"}}>
                                <Link  to = {"/ella/user/userType/extendsValueAdd/"+this.props.params.userTypeId} className="btn btn-success btn-md"  >
                                    <i className="fa fa-plus-circle"></i> {language()['add']}
                                </Link>
                            </div>
                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <div >
                                <BootstrapTable data = {this.state.list} height={'auto'} bordered={ true }  remote={true} fetchInfo={{ dataTotalSize: this.state.total }} striped hover pagination={true} options={options} ref='table' >
                                    <TableHeaderColumn isKey dataField='id' hidden={true}> id</TableHeaderColumn>
                                    <TableHeaderColumn  dataFormat={this.userTypeChange}> {language()['userTypeName']}</TableHeaderColumn>
                                    <TableHeaderColumn dataField='attributeCode'> {language()['extendedCoding']}</TableHeaderColumn>
                                    <TableHeaderColumn dataField='attributeName'> {language()['extendedName']}</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={this.formTypeChange} width="120" > {language()['formType']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataField='remark'>{language()['remark']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataFormat={this.handle}  columnClassName="td-mid">{language()['operation']}</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        </div>
                    </div>
                </section>
                <ModalDel id="tipModal" delModSure = {this.delClick.bind(this,this.state.delRow.id)}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/user/userType/extendsValue.js